import { Link } from 'react-router-dom'

import {
  COMMAND_DECK_MARKETING_PREVIEW_HOSTS,
  isCommandDeckPreviewEnabled,
  MARKETING_BOOK_DEMO_URL,
} from './config/commandDeckMvp'
import { CommandDeckPage } from './CommandDeckPage'

export function CommandDeckPreviewRoute() {
  if (!isCommandDeckPreviewEnabled()) {
    return (
      <div className="command-deck-preview-disabled" style={{ padding: 32, maxWidth: 520 }}>
        <h1 style={{ fontSize: '1.25rem', marginBottom: 12 }}>Command Deck preview unavailable</h1>
        <p style={{ lineHeight: 1.5, opacity: 0.85, marginBottom: 16 }}>
          Creator Beta preview is only enabled on the marketing app host (
          {COMMAND_DECK_MARKETING_PREVIEW_HOSTS.join(', ')}) or when{' '}
          <code>VITE_COMMAND_DECK_PREVIEW=1</code> is set at build time.
        </p>
        <p style={{ display: 'flex', flexWrap: 'wrap', gap: 12 }}>
          <Link to="/access">Request access</Link>
          <a href={MARKETING_BOOK_DEMO_URL} target="_blank" rel="noreferrer">
            Book a demo
          </a>
        </p>
      </div>
    )
  }

  return <CommandDeckPage />
}
